import type { BulkLoads, BulkLoadPartial, BulkLoadExact } from '../../../../types'

import { useMemo } from 'react'

interface SplittedLoads {
  exact: BulkLoadExact[]
  partial: BulkLoadPartial[]
}

export function useSplitAndSortLoadsByType(bulkLoads: BulkLoads): SplittedLoads {
  return useMemo(() => {
    const exact = Object.values(bulkLoads.exact)
    const partial = Object.values(bulkLoads.partial)

    exact.sort(sortExact)
    partial.sort(sortPartial)

    return { exact, partial }
  }, [bulkLoads])
}

function sortExact(a: BulkLoadExact, b: BulkLoadExact) {
  if (a.addedTimestamp === -1 && b.addedTimestamp !== -1) {
    return -1
  }
  if (a.addedTimestamp !== -1 && b.addedTimestamp === -1) {
    return 1
  }
  if (a.addedTimestamp === -1 && b.addedTimestamp === -1) {
    return a.name.localeCompare(b.name)
  }

  // sort by timestamp ascending (oldest first, newest last)
  return a.addedTimestamp - b.addedTimestamp
}

function sortPartial(a: BulkLoadPartial, b: BulkLoadPartial) {
  const countDiff = a.value - b.value
  if (countDiff !== 0) return -countDiff

  return a.name.localeCompare(b.name)
}
